export default function ({ $gsap }) {
  $gsap.config({ nullTargetWarn: false })
}
